import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AsyncPipe, CommonModule, NgIf} from '@angular/common';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {BehaviorSubject, share} from 'rxjs';
import {IAWork} from '@app/4dm1n/works-dashboard/works-dashboard.service';
import {environment} from '@environments/environment';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {DxProgressBarModule} from 'devextreme-angular';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ToastrService} from 'ngx-toastr';
import Bugsnag from '@bugsnag/js';
import {LoadingDirectiveModule} from "../../../../@shared/loading-directive/loading-directive.module";

@Component({
    selector: 'app-worker-indicator',
    templateUrl: './worker-indicator.component.html',
    imports: [
        DxProgressBarModule,
        TranslateModule,
        MatIconModule,
        LoadingDirectiveModule,
        NgIf,
        MatTooltipModule,
        AsyncPipe
    ],
    styleUrls: ['./worker-indicator.component.scss']
})
export class WorkerIndicatorComponent extends OnDestroyMixin implements OnInit {

  private baseCollection = environment.firestoreWorkersCollection;
  public workerStatus$: BehaviorSubject<IAWork> = new BehaviorSubject(null);

  @Input()
  workName: string;

  @Input()
  workId: string;

  @Input()
  toastMessages = true;

  @Output()
  workerFinished = new EventEmitter<any>();
  @Output()
  workerError = new EventEmitter<boolean>();

  curStep = 0;
  lastMessageId: string[] = [];
  messages: { id: string, date: Date, value: string }[] = [];

  constructor(
    private afs: AngularFirestore,
    private toastr: ToastrService,
  ) {
    super();
  }

  ngOnInit(): void {
    try {
      this.afs.doc<IAWork>(`${this.baseCollection}/${this.workName}/list/${this.workId}`)
        .valueChanges()
        .pipe(
          untilComponentDestroyed(this),
        )
        .subscribe((data) => {
          if (data) {

            this.workerStatus$.next(data);

            if (data.isError) {
              this.workerError.emit(true);
            }

            if (data.isFinished) {
              this.workerFinished.emit(data.result?.message);
            }

            if (data?.progress?.step) {
              if (this.curStep < data.progress.step) {
                this.curStep = data.progress.step;
              }
            }

            if (data?.message?.id) {
              if (!this.lastMessageId.includes(data.message?.id)) {
                this.lastMessageId.push(data.message.id);
                this.messages.push(data.message);
                if (this.toastMessages) {

                  this.toastr.info(
                    data.message.value,
                    `${data.workName} - ${data.workId}`,
                    {
                      closeButton: true,
                      timeOut: 5000,
                      progressBar: true,
                      enableHtml: true,
                      positionClass: 'toast-bottom-left',
                      onActivateTick: true,
                      newestOnTop: false,
                    });


                }
              }
            }

            // console.log(data.progress.step);

          }
        });
    }catch (e){
      Bugsnag.notify('Firebase connection failed, WorkIndicatorComponent', e);
      console.log('Firebase connection failed, WorkIndicatorComponent', e);
    }


  }

}
